const uuid = require("uuid");

export default class Sheet {
    constructor(
        size = {
            height: 500,
            width: 500,
        },
        options = {
            isStartingSheet: false,
        },
        zoom = 1.0,
        sheetTemplate = undefined,
        thumbnail = '',
    ) {
        this.objects = [];
        this.id = options.isStartingSheet ? 1 : uuid.v4();
        this.zoom = zoom;
        this.size = size;
        this.backgroundColor = '#ffffff';
        this.thumbnail = thumbnail;
        this.options = options;
        this.history = undefined;

        if(sheetTemplate) {
            this.sheetTemplate = sheetTemplate;
            this.size = sheetTemplate.canvasSize;
        }
    }

    setSheetHistory = (history) => {
        this.history = history;
    }
    updateSheetSize = (size) => {
        this.size = size;
    }
}
